<template>
  <div class="container">
    <div class="col-lg-6 col-md-8 ml-auto mr-auto">
      <form @submit.prevent="remindPassword">
        <card class="card card-white" header-classes="p-0">
          <template slot="header">
            <img src="img/card-warning.png" alt=""/>
          </template>

          <div v-if="remindPasswordInitiated4Email === ''">
            <h1 class="card-title text-muted">{{ $t('passwordForgot.title') }}</h1>
            <h4 class="card-title text-muted">{{ $t('passwordForgot.subTitle') }}</h4>
            <base-input
              v-validate="'required'"
              name="email"
              :error="getError('email')"
              v-model="model.email"
              type="email"
              :placeholder="$t('passwordForgot.emailPlaceholder')"
              addon-left-icon="tim-icons icon-email-85"
            >
            </base-input>


            <base-alert v-if="alert" type="danger" dismissible>
              {{ $t('passwordForgot.failedText') }} ({{ error }})
            </base-alert>

            <div slot="footer">
              <base-button native-type="submit" type="warning" class="mb-3" size="lg" block :loading="updating">
                {{ $t('passwordForgot.actionButtonText') }}
              </base-button>

              <!--            <div class="pull-right">-->
              <!--              <h6><a href="#" class="link footer-link"> {{ $t('passwordForgot.helpLinkText') }}</a></h6>-->
              <!--            </div>-->
            </div>
          </div>
          <div v-else>
            <h1 class="card-title text-muted">{{ $t('passwordForgot.actionSuccess') }}</h1>
            <h3 class="text-danger">{{ remindPasswordInitiated4Email }}</h3>
          </div>

        </card>
      </form>
    </div>
  </div>
</template>
<script>
import {BaseAlert} from 'src/components'
import {mapActions, mapState} from "vuex";

export default {
  components: {
    BaseAlert
  },
  data() {
    return {
      remindPasswordInitiated4Email: '',
      alert: false,
      model: {
        email: '',
      }
    };
  },
  computed: {
    ...mapState({
      error: state => state.psw.error,
      updating: state => state.psw.updating,
    }),
  },
  methods: {
    ...mapActions(['PasswordForgot']),
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    async remindPassword() {
      let isValidForm = await this.$validator.validateAll();
      if (isValidForm) {
        const payload = {
          email: this.model.email,
          language: this.$i18n.locale,
        }
        this.PasswordForgot(payload).then(() => {
          if (this.error != null) {
            this.alert = true
            // got error, don't reset form
          } else {
            this.remindPasswordInitiated4Email = this.model.email
          }
        });
      }
    },
    resetForm: function () {
      this.alert = false;
      this.remindPasswordInitiated4Email = '';
      // resetting form
      this.model = {
        email: '',
      }

      // reset validation errors
      this.$validator.reset()
    }
  }
};
</script>
<style>
</style>
